export default "__VITE_ASSET__B0Y0rJ5O__"